import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAddCircle = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M11 7v4H7a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4V7a1 1 0 1 0-2 0Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm8-10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z", fill: color })));
};
export default factorySvgIcon(SvgAddCircle);
//# sourceMappingURL=SvgAddCircle.js.map